import * as XLSX from 'xlsx';

export class TableUtil {

  /*excelHeaders:string[] = ["Nombre","Activo/Inactivo","Clase","Familia","Estado","Ambiente",
  "Criticidad","Descripcion","Nombre del Sistema", "Direccion IP","Version Motor BD","IP Motor BD",
  "Contacto Responsable","Servidor", "Tipo Base de Datos"];

  templateToExcel:string[][] = [this.excelHeaders,[]];*/

  static exportToExcelModel(myDataModels: any[] , name?: string) {
    let timeSpan = new Date().toISOString();
    let prefix = name || "ExportResult";
    let fileName = '';
    if(name !== undefined && name.includes("Requerimientos a Evaluar")){
      fileName = `${prefix}`;
    }else{
      fileName = `${prefix}-${timeSpan}`;
    }

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(myDataModels);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  static exportDataExcel(data: any, filename: string) {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, filename);
  }

  static exportToExcel(tableId: string, name?: string) {
    let timeSpan = new Date().toISOString();
    let prefix = name || "ExportResult";
    let fileName = `${prefix}-${timeSpan}`;
    let targetTableElm = document.getElementById(tableId);
    let wb = XLSX.utils.table_to_book(targetTableElm, <XLSX.Table2SheetOpts>{ sheet: prefix });
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  static exportToExcelModelMotoresBdd(myDataModels: any[] , name?: string) {

    let timeSpan = new Date().toISOString();
    let prefix = name || "ExportResult";
    let fileName = `${prefix}-${timeSpan}`;

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(myDataModels);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }



}
